
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alerts/management",
      function () {
        return require("private-next-pages/alerts/management/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alerts/management"])
      });
    }
  